import React, { useContext } from "react"

import Search from "./Search"
import { FirebaseContext } from "./Firebase"
import { useTranslation } from 'next-i18next'
import { getIndexKeywords, getSuggestions } from "../SEO/queries"

const LinkList = ({ query }) => {
  let linkList
  if (query) {
    linkList = getSuggestions(query)
  } else {
    linkList = getIndexKeywords()
  }
  
  if(!linkList) return <></>

  return (
    <ol
      className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4
        p-4 text-sm gap-4 text-gray-500"
    >
      {linkList.map(q => (
        <a href={`/furniture/${q.replace(/ /g, "-")}`} className="capitalize" key={q}>
          <li>{q}</li>
        </a>
      ))}
    </ol>
  )
}
export { LinkList }

const SearchPage = ({resultsState, searchState, showLinkList = !!searchState?.query}) => {
  const fb = useContext(FirebaseContext)
  const { logEvent } = fb
  const { t } = useTranslation()

  return (
    <div className="max-w-5xl mx-auto">
      <Search
        InnerButton={function Button() {
          return <>{t("open")}</>
        }}
        resultsState={resultsState}
        customState={searchState}
        addProduct={product => event => {
          logEvent("open_product", {
            source: "search page",
            product_name: product.product_name,
            product_price: product.price,
            product_id: product.id,
            merchant_name: product.merchant_name,
          })
        }}
      />
      {showLinkList && (
        <div className="mt-10">
          <LinkList query={searchState?.query} />
        </div>
      )}
    </div>
  )
};

export default SearchPage;
